import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { useSiteNav } from "@/hooks/useSiteNav";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Capabilities } from "@/components/Capabilities";
import { Transmission } from "@/components/Transmission";
import { Substation } from "@/components/Substation";
import { Renewable } from "@/components/Renewable";
import { Projects } from "@/components/Projects";
import { TrustedBy } from "@/components/TrustedBy";
import { Presence } from "@/components/Presence";
import { Safety } from "@/components/Safety";
import { WhyVec } from "@/components/WhyVec";
import { People } from "@/components/People";
import { Careers } from "@/components/Careers";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileCta } from "@/components/MobileCta";

const SiteLayout = ({ children }) => {
    useLenis();
    const go = useSiteNav();

    return (
        <div className="App bg-white text-vec-charcoal">
            <Nav onNavigate={go} />
            <main>{children}</main>
            <Footer onNavigate={go} />
            <MobileCta onNavigate={go} />
            <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: "4px" } }} />
        </div>
    );
};

const HomePage = () => (
    <>
        <Hero />
        <Marquee />
        <About />
        <Capabilities />
        <Transmission />
        <Substation />
        <Renewable />
        <Projects />
        <TrustedBy />
        <Presence />
        <Safety />
        <WhyVec />
        <People />
        <Contact />
    </>
);

const CareersPage = () => (
    <div data-testid="careers-page" className="pt-[72px]">
        <Careers />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <SiteLayout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </SiteLayout>
        </BrowserRouter>
    );
}

export default App;
